import { ITCOSubmission } from 'types';
import { tcoFieldsIds, tcoGeneralInformationFieldIds } from './constants';

const {
  termsFieldId,
  costOfCapitalFieldId,
  varDiscountFieldId,
  salesTaxFieldId,
  shippingHandlingFieldId,
  spectrumPromotionsFieldId,
  numberOfSitesFieldId,
  laborCostsFieldId,
  avgTravelCostPerSiteFieldId,
  costPerDropSpectrumFieldId,
  costPerDropDiyFieldId,
  scissorLiftCostSpectrumFieldId,
  scissorLiftCostDiyFieldId,
} = tcoFieldsIds;

const {
  operatingLabourCostPerHourId,
  annualLaborInflationRateId,
  efficiencyLaborTransferOrReductionId,
  averageTermCostId,
} = tcoGeneralInformationFieldIds;

export const tcoFormsDefaultValues: Partial<ITCOSubmission>[] = [
  {
    fieldId: termsFieldId,
    answer: '3',
  },
  {
    fieldId: costOfCapitalFieldId,
    answer: '9.6',
  },
  {
    fieldId: varDiscountFieldId,
    answer: '45',
  },
  {
    fieldId: salesTaxFieldId,
    answer: '0.00',
  },
  {
    fieldId: shippingHandlingFieldId,
    answer: '2',
  },
  {
    fieldId: spectrumPromotionsFieldId,
    answer: '0.00',
  },
  {
    fieldId: operatingLabourCostPerHourId,
    answer: '125.00',
  },
  {
    fieldId: annualLaborInflationRateId,
    answer: '8.0',
  },
  {
    fieldId: efficiencyLaborTransferOrReductionId,
    answer: '70',
  },
  { fieldId: averageTermCostId, answer: '135.27' },
  {
    fieldId: numberOfSitesFieldId,
    answer: '',
  },
  {
    fieldId: laborCostsFieldId,
    answer: '150.00',
  },
  {
    fieldId: avgTravelCostPerSiteFieldId,
    answer: '550.00',
  },
  {
    fieldId: costPerDropSpectrumFieldId,
    answer: '0.00',
  },
  {
    fieldId: costPerDropDiyFieldId,
    answer: '180.00',
  },
  {
    fieldId: scissorLiftCostSpectrumFieldId,
    answer: '1100.00',
  },
  {
    fieldId: scissorLiftCostDiyFieldId,
    answer: '1100.00',
  },
];
